import { call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
    DevicesChannelsFetchError,
    DevicesChannelsFetchSuccess,
    DevicesFetchError,
    DevicesFetchSuccess,
} from '@api/store/deviceDetails/actions';
import { DeviceDetailsActionTypes, DevicesFetchStartAction } from '@api/store/deviceDetails/types';
import { getUserAgentChannelStats, getUserAgentStats } from '@api/services/ElasticApi';
import { errorToast } from './commonGenerators/errorToast';

function* fetchDeviceDetailsStats(action: DevicesFetchStartAction): any {
    const { from, to } = action.payload;

    try {
        const response = yield call(getUserAgentStats, { from, to });
        const deviceDetailsStats = response.data;
        const { deviceDetails } = yield select((state): any => state.reports);

        const updatedDeviceDetailsStats = {
            ...deviceDetails,
            deviceDetailsStats,
        };
        yield put(DevicesFetchSuccess(updatedDeviceDetailsStats));
    } catch (e) {
        yield call(errorToast, e);
        yield put(DevicesFetchError());
    }
}

function* watchDeviceDetails(): any {
    yield takeLatest(DeviceDetailsActionTypes.GET_DEVICE_DETAILS, fetchDeviceDetailsStats);
}

function* fetchDeviceDetailsChannelStats(action): any {
    const { from, to, channelName } = action.payload;

    try {
        const response = yield call(getUserAgentChannelStats, { from, to, channelName });
        const deviceDetailsStats = response.data;
        const { deviceDetails } = yield select((state): any => state.reports);

        const updatedDeviceDetailsStats = {
            ...deviceDetails,
            deviceDetailsStats,
        };

        yield put(DevicesChannelsFetchSuccess(updatedDeviceDetailsStats));
    } catch (e) {
        yield call(errorToast, e);
        yield put(DevicesChannelsFetchError());
    }
}

function* watchDeviceDetailsChannel(): any {
    yield takeLatest(DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS, fetchDeviceDetailsChannelStats);
}

const deviceDetailsSagas = [fork(watchDeviceDetails), fork(watchDeviceDetailsChannel)];
export default deviceDetailsSagas;
